"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/material-ui/utils/autoPrefix.js
// module id = 122
// module chunks = 0